import {
  faCircleExclamation,
  faCircleInfo,
  faExclamationTriangle,
} from '@fortawesome/pro-solid-svg-icons';

import type {AppErrorKind} from '../../utils/errors';
import type {IconDefinition} from '@fortawesome/pro-solid-svg-icons';

type KindConfig = {
  icon: IconDefinition;
  iconClassName: string;
  textClassName: string;
  defaultTitle: string;
};

export const ERROR_KIND_CONFIG: Record<AppErrorKind, KindConfig> = {
  critical: {
    icon: faExclamationTriangle,
    iconClassName: 'text-tomato9',
    textClassName: 'text-tomato11',
    defaultTitle: 'Something went wrong',
  },
  warning: {
    icon: faCircleExclamation,
    iconClassName: 'text-amber9',
    textClassName: 'text-amber11',
    defaultTitle: 'Something needs attention',
  },
  informative: {
    icon: faCircleInfo,
    iconClassName: 'text-blue9',
    textClassName: 'text-blue11',
    defaultTitle: 'Temporarily unavailable',
  },
};
